import amapi from '@/api/amapi'

import {
  path,
  caching,
  // dummy_data,
  applications_alt
} from '@/helpers/wizard'

const initialState = () => ({
  step: 1,
  mode: 'onboarding',
  // First step
  path: path,
  service_id: null,
  serviceName: '',
  serviceDomain: '',
  applications: [],
  domains: [],
  applications_alt: applications_alt,
  ticketID: '',
  url: '',
  wordpress: {
    themes: [],
    plugins: [],
    caching: caching,
  },
  first_step: {
    website_alt_show: false,
  },
  second_step: {
    sitepad: [],
    woocommerce: [],
    themes: [],
    plugins: [],
    domains: [],
  }
})

const state = initialState

const getters = {
  step: state => state.step,
  mode: state => state.mode,
  // First step
  path: state => state.path,
  service_id: state => state.service_id,
  serviceName: state => state.serviceName,
  domains: state => state.domains,
  serviceDomain: state => state.serviceDomain,
  applications: state => state.applications,
  applications_alt: state => state.applications_alt,
  website_alt_show: state => state.first_step.website_alt_show,
  // Second step
  second_step: state => state.second_step,
  second_step_data: state => {
    return {
      wordpress: state.wordpress,
      sitepad: state.sitepad,
      woocommerce: state.woocommerce
    }
  },
  ticket_id: state => {
    return state.ticketID
  },
  url: state => {
    return state.url
  }
}

const mutations = {
  SET_STEP (state, step = Number) {
    state.step = step
  },
  SET_WIZARD_MODE (state, mode) {
    state.mode = mode
  },
  SET_APPLICATIONS (state, applications) {
    state.applications = applications
  },
  SET_SERVICE_ID (state, id) {
    state.service_id = id
  },
  SET_SERVICE_NAME (state, name) {
    state.serviceName = name
  },
  SET_DOMAINS (state, domains) {
    state.domains = domains
  },
  SET_SERVICE_DOMAIN (state, domain) {
    state.serviceDomain = domain
  },
  SHOW_ALT_WEBSITE (state, show = false) {
    state.first_step.website_alt_show = show
  },
  // Step 2
  // SET_WORDPRESS_THEMES (state, themes) {
  //   state.wordpress.theme = themes
  // },
  // SET_WORDPRESS_PLUGINS (state, plugins) {
  //   state.wordpress.plugins = plugins
  // },
  SET_TICKET_ID (state, ticket_id) {
    state.ticketID = ticket_id
  },
  SET_APP_URL (state, url) {
    state.url = url
  },
  SET_STEP2_THEMES (state, themes) {
    state.second_step.themes = themes
  },
  SET_STEP2_PLUGINS (state, plugins) {
    state.second_step.plugins = plugins
  },
  SET_STEP2_DOMAINS (state, domains) {
    state.second_step.domains = domains
  },
  CLEAR_STEP2 (state) {
    state.second_step.themes = []
    state.second_step.plugins = []
    state.second_step.domains = []
  },
  CLEAR_WIZARD_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  /**
   * Initialize data required by the wizard interface.
   * @param commit
   * @param service_id
   * @returns {Promise<void>}
   */
  async getApplications ({ commit }, service_id = undefined) {
    try {
      const {
        applications,
        serviceID,
        serviceDomain,
        serviceName,
        // wordpressThemes,
        // wordpressPlugins
      } = await amapi.makecall('wizard_step1', { serviceID: service_id })

      commit('SET_APPLICATIONS', applications)
      commit('SET_SERVICE_ID', serviceID)
      commit('SET_SERVICE_DOMAIN', serviceDomain)
      commit('SET_SERVICE_NAME', serviceName)
      // commit('SET_WORDPRESS_THEMES', wordpressThemes)
      // commit('SET_WORDPRESS_PLUGINS', wordpressPlugins)
    } catch (e) {
      throw e
    }
  },

  /**
   * Process completion of the wizard.
   * @param commit
   * @param getters
   * @param rootGetters
   * @returns {Object<{resultmsg, applicationExist, deployed}>}
   */
  async submitData ({ commit, getters, rootGetters }) {
    try {
      const path = rootGetters['wizard_model/path']
      const application = rootGetters['wizard_model/application']
      let data

      const basic_model = {
        serviceID: getters.service_id,
        path: path,
        domain: getters.serviceDomain
      }

      const wordpress_model = Object.assign({}, rootGetters['wizard_model/wordpress'])
      const migration_model = Object.assign({}, rootGetters['wizard_model/migration'])
      const starterSite = Object.assign({}, rootGetters['wizard_model/starterSite'])

      // Convert plugins array to CSV format
      wordpress_model.plugins = wordpress_model.plugins?.join(',') || ''

      // Convert true/false to digit value
      wordpress_model.ssl = +wordpress_model.ssl
      wordpress_model.ssl_exists = +wordpress_model.ssl_exists
      wordpress_model.caching = wordpress_model?.caching ? Number(wordpress_model.caching) : 0

      wordpress_model.overwrite = wordpress_model.overwrite ? true : undefined

      starterSite.logoFile = starterSite.logoFile.id
      // Convert array to CSV format
      // starterSite.headerFile = starterSite.headerFile.map(item => item.id).join(',')
      // starterSite.servicesFile = starterSite.servicesFile.map(item => item.id).join(',')
      // starterSite.aboutFile = starterSite.aboutFile.map(item => item.id).join(',')
      // starterSite.logoFiles = starterSite.logoFiles.join(',')
      // starterSite.additionalFiles = starterSite.additionalFiles.map(item => item.id).join(',')

      switch (path) {
        case 'New Website':
          basic_model.application = application.key
          if (application.flow === 'wordpress') {
            data = { ...basic_model, ...wordpress_model }
            const {
              url,
              resultmsg,
              applicationExists,
              deployed,
              email,
              password
            } = await amapi.makecall('wizard_step3', { ...data })
            commit('SET_APP_URL', url)
            return { resultmsg, applicationExists, deployed, email, password }
          }
          if (application.flow === 'sitebuilder') {
            data = { ...basic_model }
            const {
              url,
              resultmsg,
              deployed
            } = await amapi.makecall('wizard_step3', { ...data })
            commit('SET_APP_URL', url)
            return { resultmsg, deployed, url }
          }
          break
        case 'Migration':
          data = { ...basic_model, ...migration_model }
          const { ticketID, resultmsg } = await amapi.makecall('wizard_step3', { ...data })
          commit('SET_TICKET_ID', ticketID)
          return resultmsg
        case 'Starter Site':
          const otherImages = starterSite.other_images.reduce((carry, img, index) => {
            carry['otherimage' + (index + 1)] = img.id
          }, {})
          data = {
            ...basic_model,
            ...starterSite,
            ...otherImages,
            other_images: undefined,
            physicalAddress: undefined,
            contentServices: undefined,
          }
          const response = await amapi.makecall('wizard_step3', data)
          commit('SET_TICKET_ID', response?.ticketID)
          return response.resultmsg
        default: break
      }
    } catch (e) {
      throw e
    }
  },

  /**
   * Load the additional application options for step 2. Such as themes, plugins etc.
   * @param commit
   * @param getters
   * @param rootGetters
   * @param serviceID {string|number}
   * @param application {string}
   * @param flow {string}
   * @returns {Promise<void>}
   */
  async loadStepTwoData ({ commit, getters, rootGetters }, { serviceID, application, flow }) {
    let response
    try {
      response = await amapi.makecall('wizard_step2', { serviceID, application, flow })
    } catch (e) {
      throw e
    }
    const themes = Array.isArray(response.options.themes) ? response.options.themes : []
    const domains = Array.isArray(response.options.domains) ? response.options.domains : ['']
    commit('SET_DOMAINS', domains)
    commit('SET_SERVICE_DOMAIN', domains[0])
    switch (application) {
      case 'wordpress':
      case 'extendify':
      case 'wpwoocommerce':
        commit('SET_STEP2_PLUGINS', Array.isArray(response.options.plugins) ? response.options.plugins : [])
        commit('SET_STEP2_THEMES', themes)
        commit('SET_STEP2_DOMAINS', Array.isArray(response.options.domains) ? response.options.domains : [])
        break
      default: break
    }
    switch (flow) {
      case 'Starter Site':
        // Step 2 hardcoded themes for Starter Site
        commit('SET_STEP2_THEMES', [
          {
            key: 'Option A',
            url: 'https://starter-site.ggexample.com/ex1/'
          },
          {
            key: 'Option B',
            url: 'https://starter-site.ggexample.com/ex2/'
          }
        ])
        break
      default: break
    }
  },
  async skipThis () {
    try {
      await amapi.makecall('wizard_skip')
    } catch (e) {
      throw e
    }
  },
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
